// src/services/motivos-devolucion.service.ts
import api from '../../utils/axios';

export interface IMotivoDevolucion {
  Id: number;
  Nombre: string;
  Descripcion?: string;
  Activo: boolean;
  Eliminado: boolean;
}

class MotivosDevolucionService {
  async getAll(): Promise<IMotivoDevolucion[]> {
    const response = await api.post('/mantenimiento/motivo-devolucion-compra/findAll');
    return response.data;
  }

  async getById(id: number): Promise<IMotivoDevolucion> {
    const response = await api.post(`/mantenimiento/motivo-devolucion-compra/findOne/${id}`);
    return response.data;
  }
}

export const motivosDevolucionService = new MotivosDevolucionService();
export default motivosDevolucionService;
